// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text__criteria-title[data-v-1918c14f]{color:#7a7b97;width:60px}.criterion__dash[data-v-1918c14f]{color:#7a7b97;width:24px}.text__criteria-description[data-v-1918c14f]{color:#7a7b97;min-width:50%}", ""]);
// Exports
module.exports = exports;
